import { useCallback } from 'react';
import { bridge } from 'shared/src/utils';
import { GOODS_RANKING_SCREEN } from './getCommonFilterAnalytics';

export const useLogClickTypeFilter = () => {
  return useCallback((marketTypeName: string) => {
    bridge.logAnalyticsEvent({
      name: 'CLICK_TYPE_FILTER',
      analytics: {
        SCREEN: GOODS_RANKING_SCREEN,
        CATEGORY: marketTypeName,
        MARKET_TYPE: marketTypeName,
      },
    });
  }, []);
};
